var _circle, _polygon, _circle2, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2, _rect3, _path14, _path15, _path16, _polygon3, _rect4, _rect5, _rect6, _path17, _path18, _path19, _polygon4, _rect7, _rect8, _rect9, _path20, _path21, _path22, _polygon5, _polygon6, _path23, _polygon7, _path24, _polygon8, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle3, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 819.32659,
    height: 610.28377,
    viewBox: "0 0 819.32659 610.28377",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 278.88167,
    cy: 364.62648,
    r: 64.08062,
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.90331,466.68376a64.08562,64.08562,0,0,0,106.77726,67.82106,64.08614,64.08614,0,1,1-106.77726-67.82106Z",
    transform: "translate(-190.33671 -144.85811)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "279.058 364.626 279.234 364.626 282.403 546.305 275.713 546.305 279.058 364.626",
    fill: "#cbcbcb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.52777,
    cy: 261.07498,
    r: 77.18423,
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.85482,354.38009a77.19024,77.19024,0,0,1-128.61174,81.68953,77.19088,77.19088,0,1,0,128.61174-81.68953Z",
    transform: "translate(-190.33671 -144.85811)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "390.316 261.075 390.104 261.075 386.287 479.905 394.345 479.905 390.316 261.075",
    fill: "#cbcbcb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.58084,333.6343l10.47979-8.38181c-8.14129-.8982-11.48637,3.54187-12.8554,7.05623-6.36028-2.641-13.28422.82017-13.28422.82017l20.96809,7.61217A15.867,15.867,0,0,0,437.58084,333.6343Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M411.164,261.3069l10.47974-8.38182c-8.14128-.89819-11.48637,3.54189-12.85539,7.05622-6.36029-2.641-13.28423.82016-13.28423.82016l20.96809,7.61218A15.8673,15.8673,0,0,0,411.164,261.3069Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M559.6222,308.0693l10.47974-8.38182c-8.14128-.8982-11.48637,3.54188-12.85539,7.05621-6.36028-2.641-13.28422.82019-13.28422.82019l20.96808,7.61215A15.86714,15.86714,0,0,0,559.6222,308.0693Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M549.26646,624.42805s.401-8.40227,8.62135-7.42564",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M605.107,624.42805s.401-8.40227,8.62136-7.42564",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M588.84806,624.42805s.401-8.40227,8.62135-7.42564",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M534.3087,624.42805s-.401-8.40227-8.62135-7.42564",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M569.14925,625.00872s-.401-8.40227-8.62136-7.42563",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M441.26646,690.42805s.401-8.40227,8.62135-7.42564",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M497.107,690.42805s.401-8.40227,8.62136-7.42564",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M480.84806,690.42805s.401-8.40227,8.62135-7.42564",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M426.3087,690.42805s-.401-8.40227-8.62135-7.42564",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M461.14925,691.00872s-.401-8.40227-8.62136-7.42563",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 567.18174,
    y: 151.70519,
    width: 107.45569,
    height: 9.57526,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 567.18174,
    y: 186.97898,
    width: 107.45569,
    height: 9.57526,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 567.18174,
    y: 218.57847,
    width: 107.45569,
    height: 9.57526,
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M717.10049,301.35093a12.49281,12.49281,0,1,1,12.49279,12.49281h0A12.50677,12.50677,0,0,1,717.10049,301.35093Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M717.10049,336.62475a12.49281,12.49281,0,1,1,12.49282,12.49279h0A12.50674,12.50674,0,0,1,717.10049,336.62475Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M717.10049,368.2242a12.49281,12.49281,0,1,1,12.49282,12.4928h0A12.50675,12.50675,0,0,1,717.10049,368.2242Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.459 240.592 419.88 239.366 460.329 187.284 513.23 187.284 513.23 189.284 461.308 189.284 421.459 240.592",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 265.70519,
    width: 107.45569,
    height: 9.57526,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 300.97898,
    width: 107.45569,
    height: 9.57526,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 332.57847,
    width: 107.45569,
    height: 9.57526,
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M325.71756,427.84374h0a12.49282,12.49282,0,1,1,12.4928-12.49281A12.4928,12.4928,0,0,1,325.71756,427.84374Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M325.71756,463.11754h0a12.49281,12.49281,0,1,1,12.49283-12.49279A12.4928,12.4928,0,0,1,325.71753,463.11754Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M325.71756,494.717h0a12.49282,12.49282,0,1,1,12.49283-12.4928A12.4928,12.4928,0,0,1,325.71753,494.717Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "253.179 354.592 213.329 303.284 161.408 303.284 161.408 301.284 214.308 301.284 214.608 301.671 254.758 353.366 253.179 354.592",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 373.18174,
    y: 7.70519,
    width: 107.45569,
    height: 9.57526,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 373.18174,
    y: 42.97898,
    width: 107.45569,
    height: 9.57526,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 373.18174,
    y: 74.57847,
    width: 107.45569,
    height: 9.57526,
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M523.10049,157.35093a12.49281,12.49281,0,1,1,12.49279,12.49281h0A12.50677,12.50677,0,0,1,523.10049,157.35093Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M523.10049,192.62475a12.49281,12.49281,0,1,1,12.49282,12.49279h0A12.50674,12.50674,0,0,1,523.10049,192.62475Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M523.10049,224.2242a12.49281,12.49281,0,1,1,12.49282,12.4928h0A12.50675,12.50675,0,0,1,523.10049,224.2242Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.459 96.592 225.88 95.366 266.329 43.284 319.23 43.284 319.23 45.284 267.308 45.284 227.459 96.592",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "757.434 603.319 750.685 603.319 747.474 577.284 757.436 577.284 757.434 603.319",
    fill: "#ffb7b7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M949.49255,754.72027l-21.76429-.00081v-.27528a8.47174,8.47174,0,0,1,8.47127-8.47114h.00054l13.29289.00054Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#2f2e41"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "728.434 603.319 721.685 603.319 718.474 577.284 728.436 577.284 728.434 603.319",
    fill: "#ffb7b7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M920.49255,754.72027l-21.76429-.00081v-.27528a8.47174,8.47174,0,0,1,8.47127-8.47114h.00054l13.29289.00054Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#2f2e41"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "713.069 432.511 703.923 447.055 719.275 593.813 735.319 594.784 738.693 468.032 744.319 535.784 742.096 594.784 758.614 595.585 768.429 509.985 775.819 442.284 761.319 428.784 713.069 432.511",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M946.15542,466.14189l-25,1L897.99007,581.42535s37.65391,18.685,52.90963,1.70079l9.16911-6.7176Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#073c46"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M946.15542,466.14189l22,12.82169-8.12773,53.67831,7.12713,54.73168L944.007,583.60112s-4.73905-50.95923-1.66353-66.95923S946.15542,466.14189,946.15542,466.14189Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M921.15542,467.14189,894.8305,480.65336l2.00547,59.44757-13.58606,45.04s27.09055,8.66936,31.748-4.91482S921.15542,467.14189,921.15542,467.14189Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M956.70719,600.91777a6.681,6.681,0,0,0,2.46918-9.9425l7.94483-13.0372-6.74512-6.76037-10.961,18.56862a6.71721,6.71721,0,0,0,7.29216,11.17145Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#ffb7b7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M956.7381,486.27544l10.48819-8.31186s9.91811,8.1173,9.67362,15.8978,2.72517,49.22756,2.72517,49.22756l-16.3673,49.26393-12.189-9.75175,14.27813-38.45923-11.25131-32.81753Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M888.93062,603.23918a6.681,6.681,0,0,1-1.0446-10.19112l-6.02995-14.026,7.62983-5.74326,8.23725,19.927a6.71721,6.71721,0,0,1-8.79253,10.03336Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#ffb7b7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M905.04248,489.73468l-9.21333-9.70587s-10.96228,6.63989-11.81577,14.3773-9.62961,48.35339-9.62961,48.35339l9.26752,51.07774,13.44065-7.9383-8.72055-40.08653,15.76016-30.9063Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.11612,
    cy: 296.73839,
    r: 17.07556,
    fill: "#ffb7b7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M930.32375,426.43428c-1.72414-.3045-3.43087.47986-5.02862,1.19584s-3.38381,1.39429-5.05781.88146a5.18374,5.18374,0,0,1-3.17734-3.52389,15.31451,15.31451,0,0,1-.43091-4.89565l1.81887,1.05067-1.24217-2.08772,17.71981-1.95841c5.36137-.59255,11.37294-1.00557,15.54309,2.41575a15.49463,15.49463,0,0,1,4.46975,7.16971c3.53746,10.829,7.55377,26.60777-10.60218,29.82669-2.53057-.69979,1.5966-10.01515,1.55468-12.64038s-1.48683-5.57647-4.08136-5.97942l-1.89993,2.64217c1.21583-1.69084-3.10005-7.18229-4.17375-8.25377a17.07554,17.07554,0,0,1-2.59774-2.75407C932.28061,428.20925,932.27082,426.77818,930.32375,426.43428Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.66329,755.14189h-179a1,1,0,0,1,0-2h179a1,1,0,0,1,0,2Z",
    transform: "translate(-190.33671 -144.85811)",
    fill: "#cbcbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudy);
export default __webpack_public_path__ + "static/media/study.e3e81d16d86b6b7efcbfa42e630f6fd0.svg";
export { ForwardRef as ReactComponent };